import { type ReactNode, useState } from 'react';

import { Title } from '../components/title';
import { Search } from '../components/home/search';
import { MainNav } from '../components/home/main-nav';

import { Board } from './board';
import { Showcase } from './showcase';
import { Rewards } from './rewards';

import { X, Menu } from 'lucide-react';

import styles from './leaderboard.module.css';

export const Leaderboard = ({ children }: { children?: ReactNode }) => {
  const [menuActive, setMenuActive] = useState(false);
  return (
    <>
      <Title title="Leaderboard" />
      <div className={ styles.layout }>
        <header className={ styles.header }>
          <div data-menu={ menuActive }>
            <h1 className={ styles.siteTitle }>
              <span>
                icklesquishy.bot
              </span>
              <button
                type="button"
                className={ styles.menuButton }
                onClick={ () => setMenuActive(!menuActive) }
              >
                { menuActive ? <X /> : <Menu /> }
                <span className="visually-hidden">Menu</span>
              </button>
            </h1>
            <Search />
            <MainNav />
          </div>
        </header>
        <main className={ styles.main }>
          <div>
            <h1 className={ styles.title }>
              Leaderboard
            </h1>
            <Showcase />
            <Board />
          </div>
        </main>
        <aside className={ styles.sidebar }>
          <Rewards />
        </aside>
        { children }
      </div>
    </>
  );
};